import {
  useWSModalCustom,
  WSAlert,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { INVOICING_PATH } from "../../../Invoicing";

export const ModalExit: React.FC<WSModalCustomProps<any>> = props => {
  const history = useHistory();

  return (
    <WSModal
      title="Exit work log"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Tertiary",
            label: "Back",
            onClick: props.onClose
          },
          {
            kind: "Primary",
            label: "Exit",
            onClick: () => {
              history.push(INVOICING_PATH);
            }
          }
        ]
      }}
      {...props}
    >
      <WSList gap="L">
        <WSText.ParagraphSm color="gray500">
          Are you sure you want to exit the work log?
        </WSText.ParagraphSm>
        <WSAlert theme="info" title="About work logs" icon="info-circle">
          The edits you made to this work log will be retained. If you select
          the same engagement again in the future, you can continue editing the
          work log.
        </WSAlert>
      </WSList>
    </WSModal>
  );
};

export const useModalExit = () => useWSModalCustom(ModalExit);
